import { TSubcategory } from '../multipleCategories'

import { checkIsCategoryInBusinessUnit } from './checkIsCategoryInBusinessUnit'

export const groupSubcategoriesByBusinessUnits = (
  subcategories: TSubcategory[],
  businessUnits: string[]
) => {
  const grouped: Record<string, TSubcategory[]> = {}
  subcategories.forEach((subcategory) => {
    businessUnits.forEach((unit) => {
      if (checkIsCategoryInBusinessUnit(subcategory, unit)) {
        const entries = grouped[unit] ?? []
        entries.push(subcategory)
        grouped[unit] = entries
      }
    })
  })

  return grouped
}
